import { RouterProvider } from "react-router-dom";
import { Suspense } from "react";
import Loader from "./components/loader";
import router from "./route";

function App() {
  return (
    <Suspense fallback={<Loader isForSuspend />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}

export default App;
